<template>
    <div style="height: 100%;">
        <create-thory ref="create_theory_test" @add_success="pageQueryExamine" v-if="opt=='create_theory_test'"></create-thory>
        <view-paper ref="view_paper" :examineId="examineId" v-else-if="opt == 'view_paper'"></view-paper>
        <div class="theory-box" v-else>
            <div class="top-box">
                    <div class="btn-box" @click="createExamine">
                        <i class="iconfont icon-jiahao"></i>
                        创建考核
                    </div>
                    <div class="input-box">
                        <div @click="search">搜索</div>
                        <el-input v-model="pages.keywords" style="width: 20rem;" clearable @clear="search" @keydown.enter.native="search"
                            placeholder="请输入关键字">
                            <template slot="prefix">
                                <div class="search-ipt-box">
                                    <img style="cursor: pointer;width: 16px;height: auto;"
                                        src="../../../assets/image/magSys/search.png" @click="search" alt="">
                                </div>
                            </template>
                        </el-input>
                    </div>
            </div>
            <div class="content-box">
                    <Table :totalSize="pages.total" :pagination="true" :serialNumber="true" :operationWidth="350"
                        :currentPage="pages.current" @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize"
                        :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                        <template slot="grade" slot-scope="data">
                            <p class="blue-color" @click="stuScore(data.data.row)">查看</p>
                        </template>
                        <template slot="examineName" slot-scope="data">
                            <p class="blue-color" @click="stuScore(data.data.row)">{{ data.data.row.examineName }}</p>
                        </template>
                        <template slot="operation" slot-scope="data">
                        <div class="operation-box">
                            <el-tooltip class="item" effect="dark" content="试卷预览" placement="top-start">
                                <i class="iconfont icon-yulan" style="margin-right: 2rem;font-size: 2rem;" @click="view(data.data.row)"></i>
                            </el-tooltip> 
                            <el-tooltip class="item" effect="dark" content="详情" placement="top-start">
                                <i class="iconfont icon-xiangqing" @click="detail(data.data.row)"
                                    style="margin-right: 2rem;"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <i class="iconfont icon-bianji1" @click="edit(data.data.row)"
                                    style="margin-right: 2rem;"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <i class="iconfont icon-shanchu" @click="deleteExamine(data.data.row.id)"></i>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot="examineStatus" slot-scope="data">
                        <p>{{ filterExamineStatus(data.data.row.examineStatus) }}</p>
                    </template>
                    <template slot="completed" slot-scope="data">
                        <p class="examine-number" @click="viewPersonNum(data.data.row, 'completed')">{{
                            data.data.row.completed }}</p>
                    </template>
                    <template slot="incomplete" slot-scope="data">
                        <p class="examine-number" @click="viewPersonNum(data.data.row, 'incomplete')">{{
                            data.data.row.incomplete }}</p>
                    </template>
                    </Table>
                </div>
        </div>
        <examine-person ref="examine_person"></examine-person>
        <student-score ref="student_score"></student-score>
    </div>
</template>

<script>
import CreateThory from './theory/CreateThory.vue';
import { PageQueryExamine,DeleteExamine,GetExamineDetailById,GetExamineExcludeQuestionIds,GetSynthExamineDetailById } from '@/api/examine';
import { GetTestPaperInfo } from '@/api/paper';
import { filterExamineStatus } from '@/utils/utils';
import ExaminePerson from './virtual/ExaminePerson.vue';
import StudentScore from './theory/StudentScore.vue';
import ViewPaper from '../../personCenter/myselfPaper/ViewPaper.vue';
export default {
  components: { CreateThory, ExaminePerson, StudentScore, ViewPaper },
        data(){
            return {
                pages:{
                    current:1,
                    size:10,
                    total:0,
                    keywords:''
                },
                examineId:'',
                tableData:[],
                tableKey:[
                    {
                        name:"考核名称",
                        value:'examineName',
                        slot:'examineName'
                    },
                    {
                        name:"开始时间",
                        value:'beginTime'
                    },
                    {
                        name:"结束时间",
                        value:'endTime'
                    },
                    {
                        name:"考核状态",
                        value:'examineStatus',
                        slot:'examineStatus'
                    },
                    {
                        name:"已考核人员",
                        value:'completed',
                        slot:'completed'
                    },
                    {
                        name:"未考核人员",
                        value:'incomplete',
                        slot:'incomplete'
                    },
                    {
                        name:"合格率",
                        value:'rate'
                    },
                    {
                        name:"成绩",
                        value:'grade',
                        slot:'grade'
                    },
                    {
                        name:"操作",
                        value:'operation',
                        slot:'operation'
                    },
                ]
            }
        },
        computed:{
            opt(){
                return this.$store.state.course.operation;
            }
        },
        methods:{
            filterExamineStatus,
            /**创建考核 */
            createExamine(){
                this.$store.commit('course/changeOperation','create_theory_test');
                this.$store.commit('backend/changeOptlabel','创建考核');
                this.$nextTick(()=>{
                    let dialog=this.$refs.create_theory_test;
                    if(dialog){
                        dialog.searchSub();
                    }
                })
            },
            /**试卷预览 */
            view(item){
                    this.examineId=item.id;
                    this.$store.commit('course/changeOperation','view_paper');
                    this.$store.commit('backend/changeOptlabel','试卷预览');
                    GetSynthExamineDetailById({id:item.id}).then(res=>{
                        if(res.code==200){
                            let el=res.data.examineDetailList.find(item=>{
                                return item.resourceType=='0';
                            })
                            if(el){
                                let dialog=this.$refs.view_paper;
                                if(dialog){
                                    dialog.paperId=el.resourceId;
                                    dialog.getUserAnswerRecord();
                                }
                            }
                        }
                    })
                },
            /**查询考核详情 */
            getExamineDetailById(id){
            return new Promise(resolve=>{
                GetExamineDetailById(id).then(res=>{
                    if(res.code==200){
                        resolve(res.data);
                    }
                })
            })  
            },
            /**打开学生成绩 */
            stuScore(data){
                let dialog=this.$refs.student_score;
                if(dialog){
                    dialog.examineId=data.id;
                    dialog.examineName=data.examineName;
                    dialog.examinePaperScorePage();
                }
            },
             /**查看考核人员 */
            viewPersonNum(data, type) {
                let dialog = this.$refs.examine_person;
                if (!dialog) return;
                dialog.type = type;
                if (type == 'completed') {
                    dialog.getExamineUserInfo(data.id,true);
                    return;
                }
                dialog.getExamineUserInfo(data.id,false);
            },
            /**分页查询考核任务 */
            pageQueryExamine(){
                let params={
                    "classIds": [],
                    "current": this.pages.current,
                    "examineName": this.pages.keywords,
                    "examineStatus": "",
                    "examineType": 0,
                    "size": this.pages.size
                }
                PageQueryExamine(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            search(){
                this.pages.current=1;
                this.pageQueryExamine();
            },
            changeCurrentPage(e){
                this.pages.current=e;
                this.pageQueryExamine();
            },
            changePageSize(e){
                this.pages.current=1;
                this.pages.size=e;
                this.pageQueryExamine();
            },
            /**删除考核 */
            deleteExamine(id){
                this.$confirm('是否确认删除该条数据?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    DeleteExamine({ids:[id]}).then(res=>{
                    if(res.code==200){
                        this.$msg({
                        showClose: true,
                        type: 'success',
                        message: '删除成功'
                        });
                        if(this.tableData.length==1&&this.pages.current>1){
                            this.pages.current--;
                        }
                        this.pageQueryExamine();
                    }
                })
                  });
            },
            /**编辑考核 */
            edit(item){
                this.getExamineDetailById({id:item.id}).then(res1=>{
                    if(res1.extractionMode=='0'){
                        if(res1.paperDetailList&&res1.paperDetailList.length>0){
                            GetTestPaperInfo({id:res1.paperDetailList[0].id}).then(res=>{
                            if(res.code==200){
                                this.$store.commit('course/changeOperation','create_theory_test');
                                this.$store.commit('backend/changeOptlabel','编辑考核');
                                this.$nextTick(()=>{
                                    var dialog=this.$refs.create_theory_test;
                                    dialog.testId=item.id;
                                    res.data.beginTime=item.beginTime;
                                    res.data.endTime=item.endTime;
                                    res.data.classInfoList=res1.classInfoList;
                                    dialog.initEditData(res.data);
                                })
                            }
                        })
                        }
                    }else{
                        GetExamineExcludeQuestionIds({id:item.id}).then(res=>{
                            if(res.code==200){
                                res1.excludeQuestionIds=res.data;
                                this.$store.commit('course/changeOperation','create_theory_test');
                                this.$store.commit('backend/changeOptlabel','编辑考核');
                                this.$nextTick(()=>{
                                    var dialog=this.$refs.create_theory_test;
                                    dialog.testId=item.id;
                                    dialog.initPaperEdit(res1);
                                })
                            }
                        })
                    }
                })
            },
            /**考核详情 */
            detail(item){
                this.getExamineDetailById({id:item.id}).then(res1=>{
                    if(res1.extractionMode=='0'){
                        if(res1.paperDetailList&&res1.paperDetailList.length>0){
                        GetTestPaperInfo({id:res1.paperDetailList[0].id}).then(res=>{
                        if(res.code==200){
                            this.$store.commit('course/changeOperation','create_theory_test');
                            this.$store.commit('backend/changeOptlabel','考核详情');
                            this.$nextTick(()=>{
                                var dialog=this.$refs.create_theory_test;
                                dialog.paperId=item.id;
                                res.data.beginTime=item.beginTime;
                                res.data.endTime=item.endTime;
                                res.data.classInfoList=res1.classInfoList;
                                dialog.initEditData(res.data);
                                dialog.isDetail=true;
                            })
                        }
                    })
                    }
                    }else{
                        GetExamineExcludeQuestionIds({id:item.id}).then(res=>{
                            if(res.code==200){
                                res1.excludeQuestionIds=res.data;
                                this.$store.commit('course/changeOperation','create_theory_test');
                                this.$store.commit('backend/changeOptlabel','编辑考核');
                                this.$nextTick(()=>{
                                    var dialog=this.$refs.create_theory_test;
                                    dialog.initPaperEdit(res1);
                                    dialog.isDetail=true;
                                })
                            }
                        })
                    }
                })
            }
        },
        mounted(){
            this.pageQueryExamine();
        },
        destroyed(){
            this.$store.commit('course/changeOperation','');
            this.$store.commit('backend/changeOptlabel','');
        }
    }
</script>

<style lang="less" scoped>
.theory-box{
    height: 100%;
}
.top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.btn-box {
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);

    i {
        margin-right: 3px;
        font-size: 2rem;
    }
}

.input-box {
    display: flex;
    align-items: center;
    color: #8590B3;

    &> :nth-child(1) {
        margin-right: 1rem;
    }

    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
        padding-left: 3.5rem;
    }

    .search-ipt-box {
        display: flex;
        align-items: center;
        width: 3.5rem;
        justify-content: center;
        height: 100%;
    }
}
.content-box {
    height: calc(100% - 6rem);
    margin-top: 2rem;
}
.operation-box {
    display: flex;
    color: var(--blue);

    &> :nth-child(n) {
        cursor: pointer;
        font-size: 16px;
    }
}
.examine-number {
    color: var(--blue);
    cursor: pointer;
}
.blue-color{
    color: var(--blue);
    cursor: pointer;
}
</style>